/* tslint:disable */
export var icon = "\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"5\" height=\"8\"><path fill=\"#7A92A5\" d=\"M.313 1.353L1.02.647l3.354 3.355L1.02 7.354l-.707-.708L2.96 4.001z\"/></svg>\n";
//# sourceMappingURL=arrow-breadcrumb.svg.js.map